/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsBaseForServiceNow extends models.ServiceAccountCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsBaseForServiceNow");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsBaseForServiceNow.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsBaseForServiceNow>): ServiceAccountCredentialsBaseForServiceNow {
        let obj = Object.assign(new ServiceAccountCredentialsBaseForServiceNow(), model);
        ServiceAccountCredentialsBaseForServiceNow.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsBaseForServiceNow>): ServiceAccountCredentialsBaseForServiceNow {
        if (!model) return null;
        return ServiceAccountCredentialsBaseForServiceNow.newInstance(<ServiceAccountCredentialsBaseForServiceNow> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsBaseForServiceNow) {
        if (!obj) return;

        models.ServiceAccountCredentialsBaseForServiceNow.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsBaseForServiceNow): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsBaseForServiceNow.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Auth URL. This is a required field.
     */
    auth_url: string;

}
